import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { delay } from 'rxjs/operators';

import { Scopes, Scope } from '../entities/entities';
import { ConfigService } from './config.service';
import { HttpClientService } from './http-client.service';

@Injectable()
export class ScopeService {
  private limit = 25;

  constructor(
    private httpClient: HttpClientService,
    private config: ConfigService) { }

    /**
     * @description Search for scopes by name.
     * @param term search term
     * @param token starting index of returned results
     */
  search(term: string, includeDetails: boolean = false, token: string = ''): Observable<Scopes> {

    let url = `${this.config.Current.productsApiBaseAddress}/v1/scopes?nameSearchText=${term}&take=${this.limit}&token=${token}`;
    if (includeDetails) {
      url += '&includeDetails=true';
    }
    return this.httpClient
      .get<Scopes>(url);
  }

  getScope(scopeId: string): Observable<Scope> {
    if (scopeId === 'new') {
      const newScope = new Scope();
      newScope.id = 'new';
      newScope.name = '';

      // delay turns this into an asnyc observable, needed for proper angular functioning
      // uses new .pipe for lettables.
      return of(newScope).pipe(delay(1));

    } else {
      const url =
        `${this.config.Current.productsApiBaseAddress}/v1/scopes/${scopeId}`;
      return this.httpClient.get<Scope>(url);
    }
  }

  createScope(scope: Scope): Observable<Scope> {
    const url = `${this.config.Current.productsApiBaseAddress}/v1/scopes`;
    return this.httpClient.post<Scope>(url, scope);
  }

  updateScope(scope: Scope): Observable<Scope> {
    const url = `${this.config.Current.productsApiBaseAddress}/v1/scopes/${scope.id}`;
    return this.httpClient.put<Scope>(url, scope);
  }

  deleteScope(scope: Scope): Observable<Scope> {
    const url = `${this.config.Current.productsApiBaseAddress}/v1/scopes/${scope.id}`;
    return this.httpClient.delete<Scope>(url, scope.concurrencyToken);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/services/scope.service.ts